import { render, staticRenderFns } from "./VEmployerEmployeesTemplatePersonalInfo.vue?vue&type=template&id=8b7f7254&lang=pug"
import script from "./VEmployerEmployeesTemplatePersonalInfo.vue?vue&type=script&lang=ts"
export * from "./VEmployerEmployeesTemplatePersonalInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmployerEmployeesTemplatePersonalInfo.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FEmployees%2FTemplate%2Fviews%2FPersonalInfo%2FVEmployerEmployeesTemplatePersonalInfo.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports